import { addDays, lightFormat } from 'date-fns';
import { PlainDateString } from '@sdk/types';
import { PersonaPickerOption } from '@sdk/components/forms/personaPickers/PersonaPicker/personaPicker.types';

import { formatEmployeeCountAppendix } from '@web/common/utils/i18n';

export const getWorkDayDates = () => {
  const dateFormat = 'yyyy-MM-dd';
  const todayDate = new Date();
  const todayFormattedDate = lightFormat(todayDate, dateFormat) as PlainDateString;
  const tomorrowFormatedDate = lightFormat(addDays(todayDate, 1), dateFormat) as PlainDateString;

  return {
    today: todayFormattedDate,
    tomorrow: tomorrowFormatedDate,
  };
};

export const createWorkByDatePersonaOption = (
  id: number,
  IDs: number[],
  label: string
): PersonaPickerOption => ({
  id,
  subtitle: formatEmployeeCountAppendix(IDs.length),
  title: label,
  type: 'everyone',
});
